var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#aaaaaa",
    d: "M16.504 8.252a.752.752 0 1 0-1.504 0a.752.752 0 0 0 1.504 0M3 10.757V6.25A3.25 3.25 0 0 1 6.25 3h11.5A3.25 3.25 0 0 1 21 6.25v11.5c0 .627-.178 1.213-.485 1.71l-6.939-6.812l-.128-.117a2.251 2.251 0 0 0-2.244-.383A5.497 5.497 0 0 0 6.5 9.5c-1.33 0-2.55.472-3.5 1.257m10.5-2.505a2.252 2.252 0 1 0 4.504 0a2.252 2.252 0 0 0-4.504 0M13.982 21a1.741 1.741 0 0 0-.495-.987l-2.237-2.238a5.52 5.52 0 0 0 .551-4.245a.751.751 0 0 1 .631.11l.093.078l6.928 6.8A3.235 3.235 0 0 1 17.75 21zM9.95 17.89a4.5 4.5 0 1 0-1.145.976l2.915 2.914a.75.75 0 1 0 1.06-1.06zM6.5 18a3 3 0 1 1 0-6a3 3 0 0 1 0 6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageNotFound);
export default __webpack_public_path__ + "static/media/image-not-found.73d7c2de529b3dfbfddc6e3b9c320b01.svg";
export { ForwardRef as ReactComponent };